import { FormGroup, FormLabel, FormSelect } from "react-bootstrap";
import { ErrorMessage } from "formik";
import React from "react";

type Option = {
  label: string;
  value: string;
};
type SelectProps = {
  options: Option[];
  value: string;
  name: string;
  className?: string;
  label?: string;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur?: (e: React.ChangeEvent<any>) => void;
  required?: boolean;
  disabled?: boolean;
};

export function Select({
  options,
  value,
  name,
  className,
  label,
  handleChange,
  handleBlur,
  required,
  disabled,
}: SelectProps) {
  return (
    <FormGroup className="mt-2">
      {label && !required && <FormLabel>{label}</FormLabel>}
      {label && required && (
        <FormLabel>
          {label} <span style={{ color: "red" }}>*</span>
        </FormLabel>
      )}
      <FormSelect
        disabled={disabled}
        value={value}
        className={className}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
      >
        {/*<option value="">Select...</option>*/}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </FormSelect>
      {required && (
        <ErrorMessage className="text-error" name={name} component="div" />
      )}
    </FormGroup>
  );
}

export default Select;
